import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { EOnboardingTaskType } from '@feathr/blackbox';
import InviteUsersModal from '@feathr/extender/components/InviteUsersModal';

import type { IUseMilestoneTaskModalsReturn } from '../../useMilestoneTaskModals';
import BuildFirstGroupModal from './BuildFirstGroupModal';
import CreateEmailCampaignModal from './CreateEmailCampaignModal';
import CreateEmailTemplateModal from './CreateEmailTemplateModal';
import CreateFirstProjectModal from './CreateFirstProjectModal';
import SetupSuperPixelModal from './SetupSuperPixelModal';
interface IMilestoneTaskModalsProps {
  modalManagement: IUseMilestoneTaskModalsReturn;
  /** You can pass any shared props that all modals might need */
  onModalComplete?: (taskType: EOnboardingTaskType) => void;
}

function MilestoneTaskModals({
  modalManagement,
  onModalComplete,
}: Readonly<IMilestoneTaskModalsProps>): JSX.Element {
  const { modalStates, modalHandlers } = modalManagement;

  return (
    <>
      {modalStates.isSetupSuperPixelModalOpen && (
        <SetupSuperPixelModal
          onClose={modalHandlers.closeSetupSuperPixelModal}
          onComplete={onModalComplete}
        />
      )}

      {modalStates.isCreateFirstProjectModalOpen && (
        <CreateFirstProjectModal
          isOpen={modalStates.isCreateFirstProjectModalOpen}
          onClose={modalHandlers.closeCreateFirstProjectModal}
          onComplete={onModalComplete}
        />
      )}

      {modalStates.isBuildFirstGroupModalOpen && (
        <BuildFirstGroupModal
          onClose={modalHandlers.closeBuildFirstGroupModal}
          onComplete={onModalComplete}
        />
      )}

      {modalStates.isCreateEmailTemplateModalOpen && (
        <CreateEmailTemplateModal
          onClose={modalHandlers.closeCreateEmailTemplateModal}
          onComplete={onModalComplete}
        />
      )}

      {modalStates.isCreateEmailCampaignModalOpen && (
        <CreateEmailCampaignModal
          onClose={modalHandlers.closeCreateEmailCampaignModal}
          onComplete={onModalComplete}
        />
      )}

      {modalStates.isInviteUserModalOpen && (
        <InviteUsersModal onClose={modalHandlers.closeInviteUserModal} />
      )}
    </>
  );
}

export default observer(MilestoneTaskModals);
